import { formatDate } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { BeneficiaryType, ErrorMessage } from 'src/app/core/constants/enum';
import { Application } from 'src/app/core/model/application.model';
import { Errors, validationType } from 'src/app/core/model/error.model';
import { CommonService } from 'src/app/services/common/common.service';
import { UboService } from 'src/app/services/ubo.service';
import { ModalController, ToastController } from '@ionic/angular';
import { nonkycModelComponent } from '../non-kyc-modal/non-kyc-model.component';
import { OfflinepopupComponent } from '../offline-popup/offline-popup.component';
import { ApplicationService } from 'src/app/services/application/application.service';
import { OTPValidationModal } from '../otpValidationModel/otp-validation-modal.component';
import { Holder } from 'src/app/core/model/holder.model';
import { HolderService } from 'src/app/services/holder/holder.service';
import { dailogModal } from '../dailog-Modal/dailog-modal';
import { CkycOkayModel } from '../okay-modal/okay-modal';

@Component({
  selector: 'app-add-ubo',
  templateUrl: './add-ubo.component.html',
  styleUrls: ['./add-ubo.component.scss'],
})
export class AddUboComponent {
  @Input() application: any;
  @Input() ubo: any;
  @Input() allocation: any;
  @Input() beneficiaryKind: string;
  isHUF: boolean = false;
  addUBO: FormGroup;
  IsControllingPersonIsBeneficiaryYesOrNoValue = 'yes';
  error = Errors;
  todayDate = new Date();
  showLoader: boolean = false;
  holder: any;
  requestId: any;
  headerText = 'Check CKYC';
  messageText = 'Please wait, Verifying CKYC';
  totalAllocation = 0;
  remainAllocation = 0;
  beneficiaryType = BeneficiaryType;
  minPercnt: string;
  showSubmitButton: boolean = true;
  ckycSearchData: string = ""
  panFixed: boolean = false;
  dobFixed: boolean = false;
  checkPan: boolean = false;

  constructor(
    private modalController: ModalController,
    private commonService: CommonService,
    private uboService: UboService,
    private toastController: ToastController,
    private readonly applicationService: ApplicationService,
    private holderService: HolderService
  ) {
    this.createForm();
  }

  ionViewWillEnter() {
    console.log('beneficiaryKind', this.beneficiaryKind);
    if (this.beneficiaryKind == "Karta" || this.beneficiaryKind === "Hindu Undivided Family") {
      this.isHUF = true
    }
    console.log('this.application.beneficiaryList', this.application.beneficiaryList);
    console.log("Filterbenefiary", this.application.beneficiaryList.filter(x => x.typeOfInvestor === "Individual"))


    var filterdList = this.application.beneficiaryList.filter(x => x.typeOfInvestor === "Individual")

    if (!this.ubo) {
      for (let i = 0; i < this.application.uboList.length; i++) {
        for (let b = 0; b < filterdList.length; b++) {
          console.log(this.application.uboList[i].investorId, filterdList[b].investorId)
          if (+this.application.uboList[i].investorId === +filterdList[b].investorId) {
            filterdList.splice(b, 1)
          }
          if (filterdList.length === 0) {
            this.form.sameAsBeneficiary.setValue('no');
            this.form.sameAsBeneficiary.updateValueAndValidity();
          }
        }
      }
      this.application.beneficiaryList = filterdList
    }

    // this.percentageHoldingListerner();
    if (this.ubo) {
      this.prefillUBO();
    }
    if (this.beneficiaryKind) {

      if (this.beneficiaryKind === 'Director/Promoter') {
        // this.minPercnt = '25';
        // this.form.percentageHolding.setValidators([
        //   Validators.required,
        //   Validators.min(25),
        // ]);
        // this.form.percentageHolding.updateValueAndValidity();
      }

      if (this.application.beneficiaryType === 'Trustee' || this.application.beneficiaryType === 'Trust' || this.application.beneficiaryType === 'Partners' || this.application.beneficiaryType === 'Partnership' || this.application.beneficiaryType === 'Partner' || this.application.beneficiaryType === 'LLP') {
        this.minPercnt = '10';
        this.form.percentageHolding.setValidators([Validators.required, Validators.min(10)]);
        this.form.percentageHolding.updateValueAndValidity();
      }

      if (this.application.beneficiaryType === 'Karta' || this.application.beneficiaryType === 'Hindu Undivided Family') {
        this.minPercnt = '100';

        this.form.percentageHolding.setValidators([Validators.required, Validators.min(100)]);
        this.form.percentageHolding.updateValueAndValidity();
      }
    }
  }

  validationBybeneficiaryKind() {
    if (this.beneficiaryKind) {

      if (this.beneficiaryKind === 'Director/Promoter') {
        this.minPercnt = '10';
        this.form.percentageHolding.setValidators([
          Validators.required,
          Validators.min(10),
        ]);
        this.form.percentageHolding.updateValueAndValidity();
      }

      if (this.application.beneficiaryType === 'Trustee' || this.application.beneficiaryType === 'Trust' || this.application.beneficiaryType === 'Partners' || this.application.beneficiaryType === 'Partnership' || this.application.beneficiaryType === 'Partner' || this.application.beneficiaryType === 'LLP') {
        this.minPercnt = '10';
        this.form.percentageHolding.setValidators([Validators.required, Validators.min(10)]);
        this.form.percentageHolding.updateValueAndValidity();
      }

      if (this.application.beneficiaryType === 'Karta' || this.application.beneficiaryType === 'Hindu Undivided Family') {
        this.minPercnt = '100';

        this.form.percentageHolding.setValidators([Validators.required, Validators.min(100)]);
        this.form.percentageHolding.updateValueAndValidity();
      }
    }
  }



  IsControllingPersonIsBeneficiaryYesOrNo(event) {
    this.IsControllingPersonIsBeneficiaryYesOrNoValue = event.value;
  }

  dismissModal() {
    this.modalController.dismiss();
  }

  get form() {
    return this.addUBO.controls;
  }

  createForm() {
    const CKYCMobileNo = /^[6-9]\d{9}$/;
    this.addUBO = new FormGroup({
      sameAsBeneficiary: new FormControl('yes'),
      selectBeneficiary: new FormControl('', [Validators.required]),
      beneficiaryTaxResidentAnyOtherCountryIfYes: new FormControl(''),
      // pan: new FormControl(''),
      // dob: new FormControl(''),

      pan: new FormControl('', validationType.PAN),
      dob: new FormControl('', [Validators.required]),
      CKYCMobileNo: new FormControl('', [Validators.pattern(CKYCMobileNo)]),
      percentageHolding: new FormControl('', [Validators.required]),
    });
  }

  prefillUBO() {
    if (this.ubo.sameAsBeneficiary === null || this.ubo.sameAsBeneficiary === undefined) {
      this.form.sameAsBeneficiary.setValue('no');
      this.form.sameAsBeneficiary.updateValueAndValidity();
    }
    else {
      this.form.sameAsBeneficiary.setValue(this.ubo.sameAsBeneficiary);
    }
    this.form.pan.setValue(this.ubo.pan);
    this.form.pan.updateValueAndValidity();
    var dateArr = this.ubo.dateOfBirth.split('-');
    var date = dateArr[2].split('T')
    var dat = date[0] + '-' + dateArr[1] + '-' + dateArr[0] + 'T00:00:00.000Z'
    this.form.dob.setValue(dat);
    this.form.dob.updateValueAndValidity();
    this.form.percentageHolding.setValue(this.ubo.percentageHolding);
    this.form.percentageHolding.updateValueAndValidity();

    for (const iterator of this.application?.beneficiaryList) {
      if (+iterator.investorId === +this.ubo.investorId) {
        this.form.selectBeneficiary.setValue(iterator.investorId.toString());
        this.form.selectBeneficiary.updateValueAndValidity();
      }
    }
  }

  onChangeAllocation(e) {
    //  let remainAllocation = 100 - +this.form.percentageHolding.value;
    //  this.totalAllocation = this.allocation;

    // // if (this.form.percentageHolding.value && this.form.percentageHolding.value == 0) {
    // //   this.form.percentageHolding.setErrors({ minimum: true });
    // // }
    // if (
    //   this.form.percentageHolding.value &&
    //   this.form.percentageHolding.value > this.totalAllocation
    // ) {
    //   this.form.percentageHolding.setErrors({ invalid: true });
    // }
  }

  isNumberKey(event) {
    if (this.commonService.isNumberKey(event)) {
      return true;
    } else {
      return false;
    }
  }

  decimalFilter(event: any) {
    const reg = /^-?\d*(\.\d{0,2})?$/;
    let input = event.target.value + String.fromCharCode(event.charCode);

    if (!reg.test(input)) {
      event.preventDefault();
    }
  }

  onSubmitCKYC() {

    if (this.form.pan.value.charAt(3).toUpperCase() !== 'P') {
      this.submit()
      return
    }

    this.form.selectBeneficiary.clearValidators();
    this.form.selectBeneficiary.updateValueAndValidity();

    this.form.pan.setValidators([Validators.required]);
    this.form.pan.updateValueAndValidity();

    this.form.dob.setValidators([Validators.required]);
    this.form.dob.updateValueAndValidity();

    this.totalAllocation = this.allocation;

    // let remainAllocation = 100 - this.allocation;
    this.totalAllocation = 100 - this.allocation;
    let remainAllocation = this.allocation;
    this.remainAllocation = this.allocation;
    var percentageHolding = this.form.percentageHolding.value
    // if (this.application.childFundId == 'FUND261' &&
    //   this.form.percentageHolding.value &&
    //   this.form.percentageHolding.value > this.totalAllocation
    // )
    if (false) {
      this.form.percentageHolding.setErrors({ invalid: true });
      return;
    }
    else if (this.form.percentageHolding.value &&
      this.form.percentageHolding.value > remainAllocation) {
      this.form.percentageHolding.setErrors({ invalid: true });
      return;
    }
    else if (this.form.percentageHolding.value &&
      this.form.percentageHolding.value < 10) {
      // this.form.percentageHolding.setErrors({ invalid: true });
      this.form.percentageHolding.setErrors({ min: true });
      this.minPercnt = "10";
      return;
    }

    this.addUBO.markAllAsTouched();
    if (this.addUBO.invalid) return;
    this.showLoader = true;
    const PAN = this.form.pan.value
    const DOB = ""

    const CKYCpayload = {
      PAN: PAN,
      DOB: DOB
    }

    this.applicationService.CKYCSearchAPI(CKYCpayload).subscribe({
      next: (CkysRes: any) => {
        const CkycData = CkysRes?.data ?? null;
        if (CkycData !== null) {
          this.ckycSearchData = CkycData;
        } else {
          this.ckycSearchData = null
        }

        let formatedDate = formatDate(this.form.dob.value, 'dd-MM-yyyy', 'en');
        const KRApayload = {
          PAN: PAN,
          DOB: formatedDate
        }

        this.applicationService.KRASearchAPI(KRApayload).subscribe({
          next: async (KRARes: any) => {
            if (KRARes.message.includes("PAN is not active or not found in KRA")) {
              this.showLoader = false;

              const modal = await this.modalController.create({
                component: dailogModal,
                backdropDismiss: false,
                cssClass: 'my-custom-class',
                componentProps: {
                  pan: PAN,
                  ckycNo: this.ckycSearchData,
                  onReturn: async () => {
                    this.showLoader = true;
                    this.continueWithoutOTP()
                  }
                }
              });
              await modal.present();
            }
            else {
              this.applicationService.KRADownloadAPI(KRApayload).subscribe({
                next: async (KRADownloadRes: any) => {
                  if (KRADownloadRes.message.includes("PAN is not active or not found in KRA")) {
                    this.applicationService.getInvestorDetailsforCKYC(PAN).subscribe(
                      async (investorRes: any) => {
                        const investorArray = investorRes || [];

                        if (investorArray.length === 0) {
                          this.showLoader = false;
                          if (this.ckycSearchData == null) {
                            const modal = await this.modalController.create({
                              component: dailogModal,
                              backdropDismiss: false,
                              cssClass: 'my-custom-class',
                              componentProps: {
                                pan: PAN,
                                ckycNo: this.ckycSearchData,
                                onReturn: async () => {
                                  this.showLoader = true;
                                  this.continueWithoutOTP()
                                }
                              }
                            });
                            await modal.present();
                          } else {
                            const modal = await this.modalController.create({
                              component: CkycOkayModel,
                              backdropDismiss: false,
                              cssClass: 'my-custom-class',
                              componentProps: {
                                onReturn: async () => {
                                  this.dismissModal();
                                  this.showSubmitButton = false;
                                  this.panFixed = true;
                                  this.dobFixed = true
                                }
                              }
                            });
                            await modal.present();
                          }
                        } else {
                          const investor = investorArray[0];
                          const spiltName = (fullName: string = '') => {
                            //const parts = fullName.trim().split(/\s+/);
                            if (fullName === null) {
                              return {
                                firstName: "",
                                middleName: "",
                                lastName: " ",
                              }
                            }
                            const parts = fullName.trim().split(/\s+/);
                            return {
                              firstName: parts[0] || '',
                              middleName: parts.length === 3 ? parts[1] : '',
                              lastName: parts.length >= 2 ? parts[parts.length - 1] : ''
                            };
                          }

                          const nameParts = spiltName(investor.investorName) ?? null;
                          const fatherNameParts = spiltName(investor.fatherName) ?? null;
                          const motherNameParts = spiltName(investor.motherFirstName) ?? null;

                          let body = {} as any;
                          body.sameAsBeneficiary = this.form.sameAsBeneficiary.value;
                          body.selectBeneficiary = this.form.selectBeneficiary.value;

                          body.dob = this.form.dob.value;
                          let dob = "";
                          if (this.form.dob.value !== "") {
                            let newDate = new Date(body.dob);
                            newDate.setDate(newDate.getDate())
                            let formatedDate = formatDate(newDate, 'dd-MM-yyyy', 'en');
                            dob = formatedDate;
                          }
                          body.pan = this.form.pan.value;
                          body.dob = dob;
                          body.mobileNo = this.form.CKYCMobileNo.value;
                          body.applicationUuid = this.application.investmentID;
                          body.percentageHolding = this.form.percentageHolding.value;
                          body.ckycStatus = "error";
                          body.ckycDetail = "";
                          if (this.ckycSearchData !== null) {
                            body.ckycNumber = this.ckycSearchData
                          } else {
                            body.ckycNumber = ""
                          }

                          body.FirstName = nameParts?.firstName ?? "",
                            body.MiddleName = nameParts?.middleName ?? "",
                            body.LastName = nameParts?.lastName ?? "",
                            body.Email = investor.email,
                            body.FatherName = fatherNameParts?.firstName ?? "",
                            body.FatherMiddleName = fatherNameParts?.middleName ?? "",
                            body.FatherLastName = fatherNameParts?.lastName ?? "",
                            body.MotherFirstName = motherNameParts?.firstName ?? "",
                            body.MotherMiddleName = motherNameParts?.middleName ?? "",
                            body.MotherLastName = motherNameParts?.lastName ?? "",
                            body.Mobile = investor.mobile,
                            body.address = investor.address,
                            body.city = investor.city,
                            body.state = investor.state,
                            body.country = investor.country,
                            body.pincode = investor.pincode
                          body.ckycDetail = this.ckycSearchData;

                          this.uboService.AddUBO(body).subscribe({
                            next: (res: any) => {
                              let data = JSON.parse(res.data)
                              this.otpVerified(res);
                            },
                            error: (err) => {
                              console.log('checkCKYCAndSaveApplication error', err)
                              this.showLoader = false
                            }
                          })
                        }
                      },
                      async (err) => {
                        console.log('getInvestorDetailsforCKYC error', err)
                        this.showLoader = false
                      }
                    )
                  }
                  else {
                    let body = {} as any;
                    body.sameAsBeneficiary = this.form.sameAsBeneficiary.value;
                    body.selectBeneficiary = this.form.selectBeneficiary.value;

                    body.dob = this.form.dob.value;
                    let dob = "";
                    if (this.form.dob.value !== "") {
                      let newDate = new Date(body.dob);
                      newDate.setDate(newDate.getDate())
                      let formatedDate = formatDate(newDate, 'dd-MM-yyyy', 'en');
                      dob = formatedDate;
                    }
                    body.pan = this.form.pan.value;
                    body.dob = dob;
                    body.mobileNo = this.form.CKYCMobileNo.value;
                    body.applicationUuid = this.application.investmentID;
                    body.percentageHolding = this.form.percentageHolding.value;
                    let ckycNumberdata = ""


                    if (this.ckycSearchData !== null) {
                      ckycNumberdata = this.ckycSearchData
                    } else {
                      ckycNumberdata = ""
                    }

                    body.KRA = JSON.stringify(KRADownloadRes);
                    body.typeOfInvestor = this.form.pan.value.charAt(3).toUpperCase() !== 'P' ? "Non-Individual" : "Individual";
                    body.ckycNumber = this.ckycSearchData;

                    this.uboService.AddUBO(body).subscribe({
                      next: (res: any) => {
                        let data = JSON.parse(res.data)
                        this.otpVerified(res);
                      },
                      error: (err) => {
                        console.log('checkCKYCAndSaveApplication error', err)
                        this.showLoader = false
                      }
                    })

                  }
                }
              });
            }
          }
        });
      },
      error: (err) => {
        console.error('CKYC search Api error', err)
      }
    });
  }

  otpVerified(res: any) {

    this.holder = res;
    // let holderData = JSON.parse(this.holder.data)
    let holderData: any;
    if (this.holder.data === undefined)
      holderData = this.holder
    else
      holderData = JSON.parse(this.holder.data)

    let body = {} as Holder;
    body.otpTriggered = true;
    body.uuid = holderData.investorId;

    this.holderService.updateHolderOTP(body).subscribe(
      (res) => {
        setTimeout(() => {
          this.modalController.dismiss();

          this.commonService.encrypt(holderData.investorId).subscribe((res: any) => {

            var investorId = res.encryptedText.replaceAll('/', 'slh').replaceAll('==', '--').replaceAll('=', '-');

            this.commonService.encrypt(holderData.investmentId).subscribe((res: any) => {

              var investmentId = res.encryptedText.replaceAll('/', 'slh').replaceAll('==', '--').replaceAll('=', '-');

              window.location.href = '/application/personal-details/' + investmentId

            });

          });



          // this.router.navigateByUrl(
          //   '/application/applicant-kyc-details/' + holderData.investorId + "/" + holderData.investmentId
          // );
        }, 3000);
      },
      (err) => { }
    );
    // this.show = 'success';
    // this.showDiv = 'kycComp';
    // this.dismissmodal()
  }

  continueWithOTP() {

    const mobileControl = this.addUBO.get('CKYCMobileNo').value;

    if (mobileControl == "") {
      this.addUBO.get('CKYCMobileNo').setErrors({ otpRequired: true });
      this.addUBO.markAllAsTouched();
      return
    }

    this.form.selectBeneficiary.clearValidators();
    this.form.selectBeneficiary.updateValueAndValidity();

    this.form.pan.setValidators([Validators.required]);
    this.form.pan.updateValueAndValidity();

    this.form.dob.setValidators([Validators.required]);
    this.form.dob.updateValueAndValidity();

    this.totalAllocation = this.allocation;

    let remainAllocation = 100 - this.allocation;
    var percentageHolding = this.form.percentageHolding.value
    this.totalAllocation = this.allocation;
    if (this.application.childFundId == 'FUND261' &&
      this.form.percentageHolding.value &&
      this.form.percentageHolding.value > this.totalAllocation
    ) {
      this.form.percentageHolding.setErrors({ invalid: true });
      return;
    }

    this.addUBO.markAllAsTouched();
    if (this.addUBO.invalid) return;

    if (this.form.pan.value.charAt(3).toUpperCase() == 'P') {
      let body = {} as any;
      body.sameAsBeneficiary = this.form.sameAsBeneficiary.value;
      body.selectBeneficiary = this.form.selectBeneficiary.value;

      body.pan = this.form.pan.value;
      body.dob = this.form.dob.value;
      body.mobileNo = this.form.CKYCMobileNo.value;
      body.applicationUuid = this.application.investmentID;
      body.percentageHolding = this.form.percentageHolding.value;

      this.showLoader = true;

      let dob = "";
      if (this.form.dob.value !== "") {
        let newDate = new Date(body.dob);
        newDate.setDate(newDate.getDate())
        let formatedDate = formatDate(newDate, 'dd-MM-yyyy', 'en');
        dob = formatedDate;
      }

      this.requestId = this.commonService.generateRequestId()
      var reqBody = {
        PAN: this.form.pan.value,
        DOB: dob,
        mobile: this.form.CKYCMobileNo.value,
        requestId: this.requestId
      }

      this.applicationService.getCKYC(reqBody).subscribe(
        async (res: any) => {
          if (res.message.includes('OTP has been sent to the registered mobile number')) {
            this.dismissModal()
            const modal = await this.modalController.create({
              component: OTPValidationModal,
              backdropDismiss: false,
              cssClass: 'myCustomClass',
              componentProps: {
                mobileNumber: this.form.CKYCMobileNo.value,
                pan: this.form.pan.value,
                dob: dob,
                requestId: this.requestId,
                onVerified: async (res: any) => {
                  body.ckycStatus = "SUCCESS";
                  body.ckycDetail = JSON.stringify(res.value.data);
                  this.uboService.AddUBO(body).subscribe(
                    async (res: any) => {
                      let uboDetail = JSON.parse(res.data)
                      this.showLoader = false;
                      this.otpVerified(uboDetail)
                    },
                    async (err) => {
                      this.showLoader = false;
                      const toast = await this.toastController.create({
                        message: err.error.message,
                        duration: 2000,
                      });
                      toast.present();
                    }
                  )
                }
              }
            });
            await modal.present();
          } else if (res.value.status === 'ERROR') {
            this.showLoader = false
            const errorMsg: string = res.message || '';
            if (errorMsg.toLowerCase().includes('date of birth')) {
              this.addUBO.get('dob').setErrors({ dobNotMatched: true })
              this.addUBO.markAllAsTouched();
            }
            if (errorMsg.toLowerCase().includes('mobile')) {
              this.addUBO.get('CKYCMobileNo').setErrors({ mobileNotMatched: true })
              this.addUBO.markAllAsTouched();
            }
            if (errorMsg.toLowerCase().includes('no record found')) {
              this.addUBO.get('pan').setErrors({ noRecordFound: true })
              this.addUBO.markAllAsTouched();
            }
            if (errorMsg.toLowerCase().includes('please try again')) {
              this.addUBO.get('pan').setErrors({ serverError: true })
              this.addUBO.markAllAsTouched();
            }
            return;
          }
        }
      )

    }
  }

  continueWithoutOTP() {

    this.addUBO.get('CKYCMobileNo').setErrors(null)

    this.form.selectBeneficiary.clearValidators();
    this.form.selectBeneficiary.updateValueAndValidity();

    this.form.pan.setValidators([Validators.required]);
    this.form.pan.updateValueAndValidity();

    this.form.dob.setValidators([Validators.required]);
    this.form.dob.updateValueAndValidity();

    this.totalAllocation = this.allocation;

    let remainAllocation = 100 - this.allocation;
    var percentageHolding = this.form.percentageHolding.value
    this.totalAllocation = this.allocation;
    if (this.application.childFundId == 'FUND261' &&
      this.form.percentageHolding.value &&
      this.form.percentageHolding.value > this.totalAllocation
    ) {
      this.form.percentageHolding.setErrors({ invalid: true });
      return;
    }

    this.addUBO.markAllAsTouched();
    if (this.addUBO.invalid) return;

    if (this.form.pan.value.charAt(3).toUpperCase() == 'P') {
      let body = {} as any;
      body.sameAsBeneficiary = this.form.sameAsBeneficiary.value;
      body.selectBeneficiary = this.form.selectBeneficiary.value;

      body.dob = this.form.dob.value;
      let dob = "";
      if (this.form.dob.value !== "") {
        let newDate = new Date(body.dob);
        newDate.setDate(newDate.getDate())
        let formatedDate = formatDate(newDate, 'dd-MM-yyyy', 'en');
        dob = formatedDate;
      }
      body.pan = this.form.pan.value;
      body.dob = dob;
      body.mobileNo = this.form.CKYCMobileNo.value;
      body.applicationUuid = this.application.investmentID;
      body.percentageHolding = this.form.percentageHolding.value;
      body.ckycStatus = "error";
      body.ckycDetail = "";
      if (this.ckycSearchData !== null) {
        body.ckycNumber = this.ckycSearchData
      } else {
        body.ckycNumber = ""
      }


      this.showLoader = true;
      this.headerText = '';
      this.messageText = '';
      this.uboService.AddUBO(body).subscribe(
        async (res: any) => {
          let body = JSON.parse(res.data)
          this.showLoader = false;
          this.dismissModal()
          this.commonService.encrypt(body.investorId).subscribe((res: any) => {

            var investorId = res.encryptedText.replaceAll('/', 'slh').replaceAll('==', '--').replaceAll('=', '-');

            this.commonService.encrypt(this.application.investmentID).subscribe((res: any) => {

              var investmentId = res.encryptedText.replaceAll('/', 'slh').replaceAll('==', '--').replaceAll('=', '-');

              window.location.href = '/application/applicant-kyc-details/' + investorId + "/" + investmentId;

            });

          });
        },
        async (error) => {
          this.showLoader = false;
          this.dismissModal();
          const toast = await this.toastController.create({
            message: 'Something went wrong',
            duration: 2000
          });
          toast.present();
        }
      )
    } else {
      this.submit();

    }
  }



  async submit() {



    if (this.form.sameAsBeneficiary.value === "yes") {
      // this.form.percentageHolding.setValidators([Validators.required]);
      // this.form.percentageHolding.setValidators([Validators.required, Validators.min(25),]);
      // this.form.percentageHolding.updateValueAndValidity();
      this.validationBybeneficiaryKind()

      this.form.selectBeneficiary.setValidators([Validators.required]);
      this.form.selectBeneficiary.updateValueAndValidity();


      this.form.pan.clearValidators();
      this.form.pan.updateValueAndValidity();

      this.form.dob.clearValidators();
      this.form.dob.updateValueAndValidity();


    }
    else {

      // this.form.percentageHolding.setValidators([Validators.required]);
      // this.form.percentageHolding.updateValueAndValidity();
      //  this.validationBybeneficiaryKind()

      this.form.selectBeneficiary.clearValidators();
      this.form.selectBeneficiary.updateValueAndValidity();

      this.form.pan.setValidators([Validators.required]);
      this.form.pan.updateValueAndValidity();

      this.form.dob.setValidators([Validators.required]);
      this.form.dob.updateValueAndValidity();

    }

    this.totalAllocation = 100 - this.allocation;
    let remainAllocation = this.allocation;
    this.remainAllocation = this.allocation;
    var percentageHolding = this.form.percentageHolding.value
    //this.totalAllocation = this.allocation;
    // if (this.application.childFundId == 'FUND261' &&
    //   this.form.percentageHolding.value &&
    //   this.form.percentageHolding.value > this.totalAllocation
    // )
    if (false) {
      this.form.percentageHolding.setErrors({ invalid: true });
      return;
    }
    else if (this.form.percentageHolding.value &&
      this.form.percentageHolding.value > remainAllocation) {
      this.form.percentageHolding.setErrors({ invalid: true });
      return;
    }

    //return;
    // if (this.ubo?.investorId) {
    //   if (this.application?.uboList.length > 0) {
    //     let data = this.application?.uboList.filter((val) => val.investorId !== this.ubo.investorId);
    //     console.log("Filtered Data   ===", data)
    //     let remaniningPercentage = 100 - (parseFloat(data[0].percentageHolding) + parseFloat(data[1].percentageHolding));

    //     if (remaniningPercentage !== parseFloat(this.form.percentageHolding.value)) {
    //       this.form.percentageHolding.setErrors({ invalid: true });
    //       return;
    //     }
    //   }
    // }

    // Commented for $UBO


    // if (!this.ubo?.investorId) {
    //   if (this.application?.uboList.length === 3) {
    //     let data = this.application?.uboList;
    //     let remaniningPercentage = 100 - (parseFloat(data[0].percentageHolding) + parseFloat(data[1].percentageHolding));
    //     if (remaniningPercentage !== parseFloat(this.form.percentageHolding.value)) {
    //       this.form.percentageHolding.setErrors({ invalid: true });
    //       return;
    //     }

    //   }
    // }

    // if (this.application?.uboList.length === 3) {
    //   console.log('Inside 1');
    //   console.log("this.form.percentageHolding.value", this.form.percentageHolding.value);
    //   let data = this.application?.uboList;
    //   let remaniningPercentage = 100 - (parseFloat(data[0].percentageHolding));
    //   console.log("remaniningPercentage", remaniningPercentage);
    //   if (remaniningPercentage != 0) {
    //     console.log('Inside if');
    //     if (remaniningPercentage < parseFloat(this.form.percentageHolding.value)) {
    //       this.form.percentageHolding.setErrors({ invalid: true });
    //       return;
    //     }
    //   }
    // }

    // if (this.application?.uboList.length === 3) {
    //   console.log("this.form.percentageHolding.value", this.form.percentageHolding.value);
    //   let data = this.application?.uboList;
    //   console.log('UBO 1' + data[0].percentageHolding);
    //   console.log('UBO 2' + data[1].percentageHolding);
    //   let remaniningPercentage = 100 - (parseFloat(data[0].percentageHolding) + parseFloat(data[1].percentageHolding));
    //   console.log("remaniningPercentage", remaniningPercentage);
    //   if (remaniningPercentage != 0) {
    //     if (remaniningPercentage < parseFloat(this.form.percentageHolding.value)) {
    //       this.totalAllocation = remaniningPercentage;
    //       console.log("this.totalAllocation" + this.totalAllocation);
    //       this.form.percentageHolding.setErrors({ invalid: true });
    //       return;
    //     }
    //   }
    // }


    // Commented for $UBO


    // if (this.application?.uboList.length === 3) {
    //   let total = parseFloat(this.application?.uboList[0].percentageHolding) + parseFloat(this.application?.uboList[1].percentageHolding) + parseFloat(this.application?.uboList[3].percentageHolding);

    // }

    // if (this.application?.uboList.length === 2) {
    //   let total = parseFloat(this.application?.uboList[0].percentageHolding) + parseFloat(this.application?.uboList[1].percentageHolding);
    //   let remaining = 100 - total;

    //   if (remaining !== parseFloat(this.form.percentageHolding.value)) {
    //     this.form.percentageHolding.setErrors({ invalid: true });

    //   }
    // }

    // if (
    //   this.form.pan.value &&
    //   this.form.pan.value.charAt(3).toUpperCase() !== 'P'
    // ) {
    //   this.form.pan.setErrors({ inProper: true });
    //   return;
    // }

    this.addUBO.markAllAsTouched();
    console.log("this.addUBO", this.addUBO);
    if (this.addUBO.invalid) return;
    let body = {} as any;

    if (this.form.pan.value.charAt(3).toUpperCase() !== 'P' && this.form.sameAsBeneficiary.value !== "yes") {
      this.dismissModal();
      const modal = await this.modalController.create({
        component: OfflinepopupComponent,
        backdropDismiss: false,
        cssClass: 'my-custom-class',
        componentProps: {
          errorMessage: ErrorMessage.IndividualError,
          isIndividual: true
        }
      });
      await modal.present();
      await modal.onDidDismiss().then((event) => { });
      return;
    }



    body.sameAsBeneficiary = this.form.sameAsBeneficiary.value;
    body.selectBeneficiary = this.form.selectBeneficiary.value;

    body.pan = this.form.pan.value;
    body.dob = this.form.dob.value;

    if (body.dob !== "") {
      let newDate = new Date(body.dob);
      newDate.setDate(newDate.getDate())
      let formatedDate = formatDate(newDate, 'yyyy-MM-dd', 'en');
      body.dob = formatedDate;
    }

    body.applicationUuid = this.application.investmentID;
    body.percentageHolding = this.form.percentageHolding.value;

    this.showLoader = true;
    if (this.ubo) {
      body.uuid = this.ubo.investorId.toString();
      body.dob = this.getDate(this.form.dob.value);

      if (
        this.ubo.sameAsBeneficiary === null || this.ubo.sameAsBeneficiary === undefined
      ) {
        body.sameAsBeneficiary = null;
      }

      this.uboService.editUBO(body).subscribe(
        (res) => {
          this.showLoader = false;
          this.modalController.dismiss();
        },
        async (err) => {

          this.showLoader = false;
          const toast = await this.toastController.create({
            message: err.error.message,
            duration: 2000,
          });
          toast.present();

        }
      );
    } else {

      let dob = "";
      if (this.form.dob.value !== "") {
        let newDate = new Date(body.dob);
        newDate.setDate(newDate.getDate())
        let formatedDate = formatDate(newDate, 'dd-MM-yyyy', 'en');
        dob = formatedDate;
      }

      var reqBody = {
        PAN: this.form.pan.value,
        DOB: dob
      }

      if (this.form.sameAsBeneficiary.value === "yes") {
        this.uboService.AddUBO(body).subscribe(
          async (res: any) => {

            let uboDetail = JSON.parse(res.data)
            this.showLoader = false;
            console.log("UBO Details  ", res)
            if (body.sameAsBeneficiary == "yes") {
              this.modalController.dismiss();
            }
            else {
              if (uboDetail.ckycCheck === 0) {
                this.dismissModal();
                const modal = await this.modalController.create({
                  component: nonkycModelComponent,
                  backdropDismiss: false,
                  cssClass: 'my-custom-class',
                  componentProps: {
                    holder: uboDetail,
                    onPanCheck: false,
                    isUBO: true,
                    BeneficiaryTypeNo: 7
                  }
                });
                await modal.present();
                modal.onDidDismiss().then((event) => { });
                return;
              }
              else {
                this.commonService.encrypt(this.application.investmentID).subscribe((res: any) => {

                  var investmentId = res.encryptedText.replaceAll('/', 'slh').replaceAll('==', '--').replaceAll('=', '-');

                  window.location.href = '/application/personal-details/' + investmentId

                });
                //window.location.href = '/application/personal-details/' + this.application.investmentID
                return;
              }
            }
          },
          async (err) => {
            this.showLoader = false;
            const toast = await this.toastController.create({
              message: err.error.message,
              duration: 2000,
            });
            toast.present();

          }
        );
      }
      else {
        this.applicationService.getCKYCForNonIndi(reqBody).subscribe(
          async (res: any) => {
            console.log('CKYC Response', res);
            console.log('res.code', res.code);
            var datares = res.value;

            if (res.code == 400) {
              var ckycDetail = {
                "PAN": this.form.pan.value,
                "DateOfBirth": dob
              }

              body.ckycStatus = "error";
              body.ckycDetail = JSON.stringify(ckycDetail);
            }
            else {

              // datares.success ="ERROR";
              if (datares.status == "ERROR") {
                body.ckycStatus = "error";
                body.ckycDetail = JSON.stringify(ckycDetail);
              }
              else {
                body.ckycStatus = "SUCCESS";
                body.ckycDetail = JSON.stringify(res.value.data);
              }
              this.uboService.AddUBO(body).subscribe(
                async (res: any) => {

                  let uboDetail = JSON.parse(res.data)
                  this.showLoader = false;
                  console.log("UBO Details  ", res)
                  if (body.sameAsBeneficiary == "yes") {
                    this.modalController.dismiss();
                  }
                  else {
                    if (uboDetail.ckycCheck === 0) {
                      this.dismissModal();
                      const modal = await this.modalController.create({
                        component: nonkycModelComponent,
                        backdropDismiss: false,
                        cssClass: 'my-custom-class',
                        componentProps: {
                          holder: uboDetail,
                          onPanCheck: false,
                          isUBO: true,
                          BeneficiaryTypeNo: 7
                        }
                      });
                      await modal.present();
                      modal.onDidDismiss().then((event) => { });
                      return;
                    }
                    else {
                      this.commonService.encrypt(this.application.investmentID).subscribe((res: any) => {

                        var investmentId = res.encryptedText.replaceAll('/', 'slh').replaceAll('==', '--').replaceAll('=', '-');

                        window.location.href = '/application/personal-details/' + investmentId

                      });
                      //window.location.href = '/application/personal-details/' + this.application.investmentID
                      return;
                    }
                  }
                },
                async (err) => {
                  this.showLoader = false;
                  const toast = await this.toastController.create({
                    message: err.error.message,
                    duration: 2000,
                  });
                  toast.present();

                }
              );


            }
          }
        );
      }
    }
  }

  getDate(dateString: string) {
    const date = new Date(dateString);
    return moment(date).format('DD-MM-YYYY');
  }
}
